import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { withStyles } from '@material-ui/core/styles';

import {
  startEditPayment,
  startAddPayment
} from '../../../store/actions/invoices';

const styles = theme => ({
  root: {
  },
  width: {
    width: '300px',
  },
});

class InvoicePayment extends Component {
  constructor(props){
    super(props);
    this.state = {
      id: undefined,
      date: undefined,
      amount: 0,
      note: "",
    };
  }

  //TODO: only handle set state when nextProps changes
  //TODO: add an INITIAL_STATE constant and use that to reset state
  componentWillReceiveProps(nextProps) {
    const payment = nextProps.payment;
    if (payment === undefined) {
      this.setState({
        id: undefined,
        date: undefined,
        amount: 0,
        note: "",
      });
    } else {
      this.setState({
        id: payment.id,
        date: payment.date,
        amount: payment.amount,
        note: payment.note,
      });
    }
  }

  handleChange = propertyName => event => {
    this.setState({
      [propertyName]: event.target.value,
    });
  };

  render() {
    const {
      classes,
      invoice,
      payment,
      showItem,
      handleClose,
      startAddPayment,
      startEditPayment
    } = this.props;

    let title = "";
    if (showItem !== undefined) {
      title = showItem === "add" ? "Add Payment" : "Edit Payment";
    }

    return (
      <Dialog
        open={showItem !== undefined ? true : false}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle className={classes.width} id="form-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="amount"
            label="Amount"
            type="number"
            value={this.state.amount}
            onChange={this.handleChange("amount")}
            fullWidth
          />
        </DialogContent>
        <DialogContent>
          <TextField
            margin="dense"
            id="note"
            label="Note"
            type="text"
            value={this.state.note}
            onChange={this.handleChange("note")}
            fullWidth
            multiline
          />
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose} >
            Cancel
          </Button>
          <Button color="primary" onClick={() => {
              //TODO: refactor as this code sucks
              const payload = {
                date: (new Date()).getTime(),
                amount: Number(this.state.amount),
                note: this.state.note
              };
              if (showItem === "add") {
                startAddPayment(invoice.id, payload);
              } else {

                startEditPayment(invoice.id, payment.id, payload);
              }
              handleClose();
            }} >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startEditPayment: (invoiceID, paymentID, updates) => dispatch(startEditPayment(invoiceID, paymentID, updates)),
  startAddPayment: (invoiceID, payment) => dispatch(startAddPayment(invoiceID, payment))
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(InvoicePayment);



// WEBPACK FOOTER //
// ./src/components/admin/Invoice/InvoicePayment.jsx